import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BusService } from 'app/services/bus.service';
import { EventsService } from 'app/services/events.service';
import { ActionsService } from 'app/services/actions/actions.service';
import { UserManagementService } from 'app/services/user/user-management.service';
import { Event } from '../../event';
import { DocumentResourceService } from 'app/services/documents/document-resource.service';

@Component({
  selector: 'app-actions-metadata-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class ActionsMetadataDocumentComponent implements OnInit {

  @Input() event: Event;
  document: any;

  constructor(
    private bus: BusService,
    private events: EventsService,
    private userService: UserManagementService,
    private documentService: DocumentResourceService
  ) {
  }


  private receiveDocuments(documents) {
    this.document = documents.find((d) => d.id === parseInt(this.event.metadata.documentId, 10));
  }

  ngOnInit() {
    this.bus.subscribe(this.events.received.data.documents.all.success, this.receiveDocuments, this);

    this.bus.publish(this.events.requested.data.documents.all);
  }
}
